/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ChargeAccountInputDto { 
    id?: number;
    name: string;
    accountId?: number;
    accountName?: string | null;
    accountCode?: string | null;
    ledgerType: string;
    creditUnionChargeTypeId?: number;
}

